import { Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import SVGInline from 'react-svg-inline';
import { useProfilesQuery } from '../../hooks/useProfile';
import { AllDone } from './AllDone';
import WidgetListItem from './WidgetListItem';
import { getDaysDifference } from './utils';

const checkCircleIcon = require('../../../images/check-circle.svg.raw');

const ProfilesWidget = ({ institute }) => {
  const { data: profiles, isPending } = useProfilesQuery('open');

  const profilesAsWidgetFormat = React.useMemo(() => {
    if (!profiles || profiles?.length === 0) return [];

    return profiles.map((profile) => {     
      const overdueDays = getDaysDifference(profile.educator_completed_at || profile.created_at)

      return {
        id: profile.id,
        userId: profile.user_id,
        name: profile.educator_full_name || 'Unknown User',
        createdAt: profile.educator_completed_at || profile.created_at,
        overdueDays: overdueDays > 0 ? overdueDays : 0
      };
    });
  }, [profiles]);

  const overdueCount = React.useMemo(() => {
    const threshold = institute?.profiling_warning_days;

    return profilesAsWidgetFormat.filter(
      (p) => threshold && (p.overdueDays || 0) >= threshold
    ).length;
  }, [institute, profilesAsWidgetFormat]);

  const onItemClick = React.useCallback((profile) => {
    if (profile) {
      window.location.href = `/admin#/profiling/profile/${profile.id}`;
    }
  }, []);

  const totalCount = profiles?.length;

  return (
    <>
      <Paper
        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px',
            borderBottom: '1px solid #eee'
          }}
        >
          <Typography
            variant="h6"
            style={{ marginRight: 12, fontSize: 16, fontWeight: '600' }}
          >
            Profiles
          </Typography>
          {isPending ? (
            <div></div>
          ) : !totalCount ? (
            <div style={{ width: 20, height: 20, alignItems: 'center' }}>
              <SVGInline svg={checkCircleIcon} />
            </div>
          ) : (
            <span
              style={{
                background: '#F5F5F5',
                borderRadius: 8,
                padding: '4px 8px',
                fontWeight: 500,
                fontSize: 13,
                color: '#1F1F1F',
                marginLeft: 0,
                display: 'inline-block'
              }}
            >
              {overdueCount}/{totalCount}{totalCount === 25 ? '+' : ''}
            </span>
          )}
        </div>
        <div
          style={{ maxHeight: 360, overflowY: 'auto', padding: 0, margin: 0 }}
        >
          {isPending ? (
            <Typography style={{ marginLeft: 16 }}>Loading...</Typography>
          ) : !totalCount ? (
            <AllDone />
          ) : (
            profilesAsWidgetFormat.map((profile, idx) => (
              <WidgetListItem
                key={profile.id}
                createdAt={profile.createdAt}
                name={profile.name}
                overdueDays={profile.overdueDays}
                onButtonClick={() => onItemClick(profile)}
                disableDivider={idx === profilesAsWidgetFormat.length - 1}
                warningThreshold={institute?.profiling_warning_days || 7}
                overdueThreshold={institute?.profiling_overdue_days || 14}
              />
            ))
          )}
        </div>
      </Paper>
    </>
  );
};

export default ProfilesWidget;
